import { render } from "./novoChamado.vue?vue&type=template&id=4c50f6f0"
import script from "./novoChamado.vue?vue&type=script&lang=js"
export * from "./novoChamado.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./novoChamado.vue?vue&type=style&index=1&id=4c50f6f0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__